import { Box, FormField, ToggleSwitch } from "@wix/design-system";
import React from "react";
import { Link_Target } from "./../../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import {
  ATTRIBUTES_NEW_TAB,
  ATTRIBUTES_NOFOLLOW,
  ATTRIBUTES_NOREFERRER,
  ATTRIBUTES_SPONSORED
} from "../../data-hooks/data-hooks.js";
import { useAttributes } from "./use-attributes.js";
const AttributesDesktop = ({
  link,
  onChange,
  t,
  tooltipProps
}) => {
  const { onToggleNewTab, onToggleNofollow, onToggleNoreferrer, onToggleSponsored } = useAttributes(
    link,
    onChange
  );
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3" }, /* @__PURE__ */ React.createElement(
    FormField,
    {
      label: t("LinkSettings_Settings_NewTab_Label"),
      labelPlacement: "left",
      labelWidth: "1fr"
    },
    /* @__PURE__ */ React.createElement(
      ToggleSwitch,
      {
        checked: link.target === Link_Target.BLANK,
        dataHook: ATTRIBUTES_NEW_TAB,
        onChange: onToggleNewTab,
        size: "small"
      }
    )
  ), /* @__PURE__ */ React.createElement(
    FormField,
    {
      infoContent: t("LinkSettings_Settings_Noreferrer_Tooltip"),
      infoTooltipProps: tooltipProps,
      label: t("LinkSettings_Settings_Noreferrer_Label"),
      labelPlacement: "left",
      labelWidth: "1fr"
    },
    /* @__PURE__ */ React.createElement(
      ToggleSwitch,
      {
        checked: link.rel?.noreferrer,
        dataHook: ATTRIBUTES_NOREFERRER,
        onChange: onToggleNoreferrer,
        size: "small"
      }
    )
  ), /* @__PURE__ */ React.createElement(
    FormField,
    {
      infoContent: t("LinkSettings_Settings_Nofollow_Tooltip"),
      infoTooltipProps: tooltipProps,
      label: t("LinkSettings_Settings_Nofollow_Label"),
      labelPlacement: "left",
      labelWidth: "1fr"
    },
    /* @__PURE__ */ React.createElement(
      ToggleSwitch,
      {
        checked: link.rel?.nofollow,
        dataHook: ATTRIBUTES_NOFOLLOW,
        onChange: onToggleNofollow,
        size: "small"
      }
    )
  ), /* @__PURE__ */ React.createElement(
    FormField,
    {
      infoContent: t("LinkSettings_Settings_Sponsored_Tooltip"),
      infoTooltipProps: tooltipProps,
      label: t("LinkSettings_Settings_Sponsored_Label"),
      labelPlacement: "left",
      labelWidth: "1fr"
    },
    /* @__PURE__ */ React.createElement(
      ToggleSwitch,
      {
        checked: link.rel?.sponsored,
        dataHook: ATTRIBUTES_SPONSORED,
        onChange: onToggleSponsored,
        size: "small"
      }
    )
  ));
};
export {
  AttributesDesktop
};
//# sourceMappingURL=attributes-desktop.js.map
